import { CLOUDFRONT_GOVIP_ROOT_URL, CLOUDFRONT_LANDING_PAGE_ROOT_URL } from '@shared/config/constants/app';

const celebrities_1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/celebrities_1_x4.png`
const celebrities_2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/celebrities_2_x4.png`
const celebrities_3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/celebrities_3_x4.png`
const celebrities_4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/celebrities_4_x4.png`
const concerts_1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/concerts_1_x4.png`
const concerts_2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/concerts_2_x4.png`
const concerts_3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/concerts_3_x4.png`
const concerts_4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/concerts_4_x4.png`
const sport_1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/sports_1_x4.png`
const sport_2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/sports_2_x4.png`
const sport_3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/sports_3_x4.png`
const sport_4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/sports_4_x4.png`
const travel_1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/travel_1_x4.png`
const travel_2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/travel_2_x4.png`
const travel_3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/travel_3_x4.png`
const travel_4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/travel_4_x4.png`
const trending_1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/trendind_1_x4.png`
const trending_2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/trendind_2_x4.png`
const trending_3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/trendind_3_x4.png`
const trending_4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/trendind_4_x4.png`
const trending_5 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/trendind_5_x4.png`
const trending_6 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/trendind_6_x4.png`
const vip_banner_perks_2 = `${CLOUDFRONT_GOVIP_ROOT_URL}/png/VIP_banner_perks_2.png`
const vuz_vip_logo_image = `${CLOUDFRONT_GOVIP_ROOT_URL}/png/img_footer_vuzlogofull_x3.png`

const voucherPreviewImage = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/banner_voucher_desktop.webp`;

const check_mark_trial_banner = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/check_mark_trial_banner.png`;
const download_icon_trial_banner = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/download_icon_trialk_banner.png`;
const watch_my_trial_banner =
  'https://d2rwz7a7lb9mw2.cloudfront.net/landingpage/banners/1754388600.png';

const voucher_new_desk = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/banner_voucher_new_desk.webp`;
const voucher_new_mob = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/banner_voucher_new_mob.webp`;

export const ImageList = {
  celebrities_1,
  celebrities_2,
  celebrities_3,
  celebrities_4,
  concerts_1,
  concerts_2,
  concerts_3,
  concerts_4,
  sport_1,
  sport_2,
  sport_3,
  sport_4,
  travel_1,
  travel_2,
  travel_3,
  travel_4,
  trending_1,
  trending_2,
  trending_3,
  trending_4,
  trending_5,
  trending_6,
  vip_banner_perks_2,
  vuz_vip_logo_image,
  voucherPreviewImage,
  check_mark_trial_banner,
  download_icon_trial_banner,
  voucher_new_desk,
  voucher_new_mob,
  watch_my_trial_banner,
};
